<template>
    <div
        class="side-menu-wrapper"
        v-bind:class="{ active: isActive }"
    >
        <div class="menu-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isActive: {
            type: Boolean,
            default: true
        },
        closeMenu: {
            type: Function
        },
    },

    data: function() {
        return {};
    },

    watch: {
        isActive(isActive) {
            document.body.classList[isActive ? 'add' : 'remove']('no-scroll');
        }
    },
};
</script>

<style lang="scss">
@import '../../../sass/_variables.scss';

.side-menu-wrapper {
    overflow: hidden;
    position: fixed;
    top: 66px;
    right: 0;
    left: 0;
    bottom: 0;
    opacity: 0;
    visibility: hidden;
    height: 100vh;
    z-index: 2002;
    transition: opacity 0.5s ease-out, visibility 0s ease-out 500ms;
    width: 100vw;
    display: flex;
    flex-direction: row-reverse;

    @media (min-width: 1024px) {
        top: 90px;
    }

    &.active {
        opacity: 1;
        visibility: visible;
        transition: opacity 0.5s ease, visibility 0s ease 0s;
    }

    .menu-content {
        width: 100vw;
        height: 100vh;
        overflow-y: scroll;
        background-color: $pale;

        @media (min-width: 1024px) {
            overflow-y: auto;
        }
    }
    a:hover {
        text-decoration: none;
    }
}
</style>
